import { render, staticRenderFns } from "./Level4Product.vue?vue&type=template&id=44baa5ce&"
import script from "./Level4Product.vue?vue&type=script&lang=js&"
export * from "./Level4Product.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports